export const rubrosHistoricos = [
     {
        "anio" : "2026",
        "descripcion" : "Disponibilidad de los recursos ejercicios anteriores",
        "trimestres" : [
            {
                "trimestre" : "Primer Trimestre",
                "url" : "../../Transparencia/zip/2026/1trim.zip"
            },/*
            {
                "trimestre" : "Segundo Trimestre",
                "url" : "../../Transparencia/zip/2026/2trim.zip"
            },
            {
                "trimestre" : "Tercer Trimestre",
                "url" : "../../Transparencia/zip/2026/3trim.zip"
            },
            {
                "trimestre" : "Cuarto Trimestre",
                "url" : "../../Transparencia/zip/2026/4trim.zip"
            }*/
        ]
    },
    {
        "anio" : "2025",
        "descripcion" : "Disponibilidad de los recursos ejercicios anteriores",
        "trimestres" : [
            {
                "trimestre" : "Primer Trimestre",
                "url" : "../../Transparencia/zip/2025/1trim.zip"
            },
            {
                "trimestre" : "Segundo Trimestre",
                "url" : "../../Transparencia/zip/2025/2trim.zip"
            },
            {
                "trimestre" : "Tercer Trimestre",
                "url" : "../../Transparencia/zip/2025/3trim.zip"
            },
            {
                "trimestre" : "Cuarto Trimestre",
                "url" : "../../Transparencia/zip/2025/4trim.zip"
            }
        ]
    },
    {
        "anio" : "2024",
        "descripcion" : "Disponibilidad de los recursos ejercicios anteriores",
        "trimestres" : [
            {
                "trimestre" : "Primer Trimestre",
                "url" : "../../Transparencia/zip/2024/1trim.zip"
            },
            {
                "trimestre" : "Segundo Trimestre",
                "url" : "../../Transparencia/zip/2024/2trim.zip"
            },
            {
                "trimestre" : "Tercer Trimestre",
                "url" : "../../Transparencia/zip/2024/3trim.zip"
            },
            {
                "trimestre" : "Cuarto Trimestre",
                "url" : "../../Transparencia/zip/2024/4trim.zip"
            }
        ]
    },
    {
        "anio" : "2023",
        "descripcion" : "Disponibilidad de los recursos ejercicios anteriores",
        "trimestres" : [
            {
                "trimestre" : "Primer Trimestre",
                "url" : "../../Transparencia/zip/2023/1trim.zip"
            },
            {
                "trimestre" : "Segundo Trimestre",
                "url" : "../../Transparencia/zip/2023/2trim.zip"
            },
            {
                "trimestre" : "Tercer Trimestre",
                "url" : "../../Transparencia/zip/2023/3trim.zip"
            },
            {
                "trimestre" : "Cuarto Trimestre",
                "url" : "../../Transparencia/zip/2023/4trim.zip"
            }
        ]
    },
    {
        "anio" : "2022",
        "descripcion" : "Disponibilidad de los recursos ejercicios anteriores",
        "trimestres" : [
            {
                "trimestre" : "Primer Trimestre",
                "url" : "../../Transparencia/zip/2022/1trim.zip"
            },
            {
                "trimestre" : "Segundo Trimestre",
                "url" : "../../Transparencia/zip/2022/2trim.zip"
            },
            {
                "trimestre" : "Tercer Trimestre",
                "url" : "../../Transparencia/zip/2022/3trim.zip"
            },
            {
                "trimestre" : "Cuarto Trimestre",
                "url" : "../../Transparencia/zip/2022/4trim.zip"
            }
        ]
    },
    {
        "anio" : "2021",
        "descripcion" : "Disponibilidad de los recursos ejercicios anteriores",
        "trimestres" : [
            {
                "trimestre" : "Primer Trimestre",
                "url" : "../../Transparencia/zip/2021/1trim.zip"
            },
            {
                "trimestre" : "Segundo Trimestre",
                "url" : "../../Transparencia/zip/2021/2trim.zip"
            },
            {
                "trimestre" : "Tercer Trimestre",
                "url" : "../../Transparencia/zip/2021/3trim.zip"
            },
            {
                "trimestre" : "Cuarto Trimestre",
                "url" : "../../Transparencia/zip/2021/4trim.zip"
            }
        ]
    },
    {
        "anio" : "2020",
        "descripcion" : "Disponibilidad de los recursos ejercicios anteriores",
        "trimestres" : [
            {
                "trimestre" : "Primer Trimestre",
                "url" : "../../Transparencia/zip/2020/1trim.zip"
            },
            {
                "trimestre" : "Segundo Trimestre",
                "url" : "../../Transparencia/zip/2020/2trim.zip"
            },
            {
                "trimestre" : "Tercer Trimestre",
                "url" : "../../Transparencia/zip/2020/3trim.zip"
            },
            {
                "trimestre" : "Cuarto Trimestre",
                "url" : "../../Transparencia/zip/2020/4trim.zip"
            }
        ]
    },
    {
        "anio" : "2019",
        "descripcion" : "Disponibilidad de los recursos ejercicios anteriores",
        "trimestres" : [
            {
                "trimestre" : "Primer Trimestre",
                "url" : "../../Transparencia/zip/2019/1trim.zip"
            },
            {
                "trimestre" : "Segundo Trimestre",
                "url" : "../../Transparencia/zip/2019/2trim.zip"
            },
            {
                "trimestre" : "Tercer Trimestre",
                "url" : "../../Transparencia/zip/2019/3trim.zip"
            },
            {
                "trimestre" : "Cuarto Trimestre",
                "url" : "../../Transparencia/zip/2019/4trim.zip"
            }
        ]
    },
    {
        "anio" : "2018",
        "descripcion" : "Disponibilidad de los recursos ejercicios anteriores",
        "trimestres" : [
            {
                "trimestre" : "Primer Trimestre",
                "url" : "../../Transparencia/zip/2018/1trim.zip"
            },
            {
                "trimestre" : "Segundo Trimestre",
                "url" : "../../Transparencia/zip/2018/2trim.zip"
            },
            {
                "trimestre" : "Tercer Trimestre",
                "url" : "../../Transparencia/zip/2018/3trim.zip"
            },
            {
                "trimestre" : "Cuarto Trimestre",
                "url" : "../../Transparencia/zip/2018/4trim.zip"
            }
        ]
    },
    {
        "anio" : "2015 - 2017",
        "descripcion" : "Ejercicios Anteriores",
        "trimestres" : [
            {
                "trimestre" : "Plataforma Nacional",
                "url" : "https://consultapublicamx.inai.org.mx/vut-web/?idSujetoObigadoParametro=2131&idEntidadParametro=13&idSectorParametro=21"
            }
        ]
    },
    {
        "anio" : "Información Histórica 21 Rubros",
        "descripcion" : "Ejercicios Anteriores",
        "trimestres" : [
            {
                "trimestre" : "Descargar",
                "url" : "../../Transparencia/zip/21rubros.zip"
            }
        ]
    }
]